import { ReactComponent as OutlineCalendar3 } from "assets/svg/outline-calendar-3.svg";
import { ReactComponent as OutlineClock2 } from "assets/svg/outline-clock-2.svg";
import { ReactComponent as OutlineCoin2 } from "assets/svg/outline-coin-2.svg";
import { ReactComponent as OutlineInfoCircle16 } from "assets/svg/outline-info-circle-16.svg";
import PatientTypeTag from "components/Dashboard/DoctorDashboard/patient-charts/components/patient-type-tag/PatientTypeTag";
import SessionTypeColorBadge from "components/session-type-color-badge/SessionTypeColorBadge";
import { MomentInput } from "moment-timezone";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import InvoicingToggle from "../../../../../calendar-view/components/scrollable-calendar-view/components/appointment-timeslot/components/invoicing-toggle/InvoicingToggle";
import styles from "../../SessionSidesheet.module.scss";
import useMainSessionDetailsSection from "./useMainSessionDetailsSection";

interface MainSessionDetailsSectionProps {
  appointment: AppointmentWithSeriesInfo & {
    invoice?: InvoiceData;
  };
  start: MomentInput;
  end: MomentInput;
  diffHrs: number;
  setError: React.Dispatch<any>;
  trackClick: (name: string) => void;
  isWaitingForInvoice: boolean;
  invoiceSessionStatus: string | null;
}

const MainSessionDetailsSection = ({
  appointment,
  start,
  end,
  diffHrs,
  setError,
  trackClick,
  isWaitingForInvoice,
  invoiceSessionStatus,
}: MainSessionDetailsSectionProps) => {
  const {
    patientType,
    patientName,
    sessionType,
    dateString,
    timeString,
    priceString,
    nextStatus,
    onInvoicingToggleStatusChange,
  } = useMainSessionDetailsSection({
    appointment,
    start,
    end,
    diffHrs,
    setError,
  });

  return (
    <div className={styles["section"]}>
      <div className={styles["patient-type-and-name"]}>
        <PatientTypeTag type={patientType} />
        <div className={styles["patient-name"]}>
          <Link
            to={`/pro-dashboard/patient-charts/${appointment.patient?.cognito_sub}`}
            onClick={() => {
              trackClick("view-patient-chart-link");
            }}
            target="_blank"
            rel="noopener noreferrer"
          >
            {patientName}
          </Link>
        </div>
      </div>

      <hr className={styles["divider"]} />

      <div className={styles["session-type"]}>
        <SessionTypeColorBadge colorId={sessionType?.color_code} />
        {appointment.appointment_type_label}
        {sessionType?.description && (
          <OverlayTrigger
            placement="right"
            overlay={
              <Tooltip id="admin-note-tooltip">
                {sessionType.description}
              </Tooltip>
            }
          >
            <OutlineInfoCircle16 className={"blue"} />
          </OverlayTrigger>
        )}
      </div>

      <div className={styles["time-date-price"]}>
        <div className={styles["text-with-icon"]}>
          <OutlineCalendar3 />
          {dateString}
        </div>
        <div className={styles["text-with-icon"]}>
          <OutlineClock2 />
          {timeString}
        </div>
        <div className={styles["text-with-icon"]}>
          <OutlineCoin2 />
          {priceString}
        </div>
      </div>

      <div className={styles["tag-container"]}>
        {appointment.statusFlags.usingInvoicing && (
          <InvoicingToggle
            disabled={isWaitingForInvoice}
            status={
              nextStatus
                ? (nextStatus as unknown as any)
                : (invoiceSessionStatus as unknown)
            }
            onStatusChange={onInvoicingToggleStatusChange}
          />
        )}
      </div>
    </div>
  );
};

export default MainSessionDetailsSection;
